export default __webpack_public_path__ + "static/media/Opposites02_05.32fc2e1a.png";